<template>
  <div class="brandSet">
    <div v-if="$route.path === '/storeinformation/brandsetting'" class="right">
      <div class="operation">
        <div class="operationBtn">
          <el-button @click="delBrandData" :disabled="delDisabled">{{$t('LanguageLib.DELETE')}}</el-button>
          <el-button type="primary" @click="addBrand">{{$t('LanguageLib.ADD_TO')}}</el-button>
        </div>
        <div class="operationSearch">
          <el-input
            placeholder=""
            prefix-icon="el-icon-search"
            v-model="searchText"
            @keyup.enter.native="searchDomainList"
          >
          </el-input>
        </div>
      </div>
      <div class="tableParent">
        <el-table
          empty-text=" "
          class="table-fixed"
          :data="tableData"
          stripe
          @selection-change="selectionChange"
          @sort-change='sortChange'
          :default-sort="defaultSort"
          ref="table"
          style="width: auto;"
          v-loading="loading"
          height="100%">
          <el-table-column
            type="selection"
            :disabled="true"
            width="45">
          </el-table-column>
          <el-table-column
            prop="sortNo"
            :label="$t('LanguageLib.SERIAL_NUMBER')"
            sortable="custom"
            min-width="80">
            <template slot-scope="scope" class="code">
              <el-tooltip class="code" effect="light" placement="top-start" >
                <span slot="content" type="sortNo">{{scope.row.sortNo}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="sortNo">{{scope.row.sortNo}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="brandNameCn"
            :label="$t('LanguageLib.BRAND_NAME')"
            sortable="custom"
            min-width="170">
            <template slot-scope="scope" class="code">
              <el-tooltip effect="light" placement="top-start" class="code">
                <span slot="content" type="brandNameCn">{{scope.row.brandNameCn}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="brandNameCn">{{scope.row.brandNameCn}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="updateDate"
            :label="$t('LanguageLib.LAST_UPDATED')"
            sortable="custom"
            min-width="120">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top-start">
                <span slot="content" type="updateDate">{{$commonfun.formatDate(scope.row.updateDate,'1')}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="updateDate">{{$commonfun.formatDate(scope.row.updateDate,'1')}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="description"
            :label="$t('LanguageLib.REMARK2')"
            sortable="custom"
            min-width="100">
            <template slot-scope="scope" class="code">
              <el-tooltip effect="light" placement="top-start" class="code">
                <span slot="content" type="description">{{scope.row.description}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="description">{{scope.row.description}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            :label="$t('LanguageLib.Operation')"
            min-width="50">
            <template slot-scope="scope">
              <el-button
                @click.native.prevent="editRole(scope.row, scope.$index, tableData)"
                :title="$t('LanguageLib.Edit')"
                type="text"
                style="color:#fff;width:30px;height:30px;background-color:#3bc6b9;border-radius:50%;line-height:30px;padding:0;">
                <i class="iconfont">&#xe60c;</i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageTotal">
      </el-pagination>
    </div>
    <router-view v-if="$route.path !== '/storeinformation/brandsetting'"></router-view>
  </div>
</template>

<script>
import storeinformationApi from '../../api/storeinformation'
export default {
  props: {
    msg: String
  },
  data () {
    return {
      seen: false, // 鼠标移入是否显示背景色
      current: 0, // 当前要显示背景色的数据
      loading: true, // loading状态
      tableData: [], // 列表数据
      pageTotal: 0, // 数据总数
      delDisabled: true, // 删除按钮默认禁用
      // 请求数据列表的函数
      getBrandList: (pageIndex, pageSize, sort, IsAsc, searchVal) => {
        this.loading = true
        storeinformationApi.GetBrandList('post', '/store/brand/list', { pageIndex: pageIndex, pageSize: pageSize, sort: sort, IsAsc: IsAsc, searchVal: searchVal })
          .then(res => {
            this.$commonfun.console.log(res)
            this.tableData = res.data.data
            this.pageTotal = res.data.total
            this.loading = false
          })
          .catch(err => {
            this.$commonfun.console.log(err)
          })
      }, // 请求数据列表的函数
      searchText: '', // 列表搜索关键词
      currentPage: 1, // 默认显示第1页数据
      pageSize: 20, // 默认每页显示20条数据
      sort: 0, // 排序字段 0：更新时间 1：序号 2：品牌名称
      IsAsc: false, // 是否顺序
      defaultSort: { prop: 'updateDate', order: 'descending' }, // 默认排序
      prevSort: 'descending', // 记录前一次的排序状态（elementUI默认有三种，即descending，ascending和null）
      prevProp: 'updateDate', // 记录前一次的prop值
      updataRouteQuery: () => {
        const query = this.$router.history.current.query
        const path = this.$router.history.current.path
        const newQuery = JSON.parse(JSON.stringify(query))
        newQuery.currentPage = this.currentPage
        newQuery.pageSize = this.pageSize
        newQuery.searchText = this.$commonfun.encodeUrl(this.searchText)
        newQuery.sort = this.sort
        newQuery.IsAsc = this.IsAsc
        newQuery.NoRefresh = true
        this.$router.push({ path, query: newQuery })
      }
    }
  },
  created () {
    if (this.$route.query.currentPage) {
      this.currentPage = this.$route.query.currentPage * 1
      this.pageSize = this.$route.query.pageSize * 1
      this.searchText = this.$commonfun.decodeUrl(this.$route.query.searchText)
      this.sort = this.$route.query.sort * 1
      this.IsAsc = this.$route.query.IsAsc ? JSON.parse(this.$route.query.IsAsc) : false
      switch (this.sort) {
        case 0:
          if (this.IsAsc) {
            this.defaultSort = { prop: 'updateDate', order: 'ascending' }
            this.prevSort = 'ascending'
          } else {
            this.defaultSort = { prop: 'updateDate', order: 'descending' }
            this.prevSort = 'descending'
          }
          this.prevProp = 'updateDate'
          break
        case 1:
          if (this.IsAsc) {
            this.defaultSort = { prop: 'sortNo', order: 'ascending' }
            this.prevSort = 'ascending'
          } else {
            this.defaultSort = { prop: 'sortNo', order: 'descending' }
            this.prevSort = 'descending'
          }
          this.prevProp = 'sortNo'
          break
        case 2:
          if (this.IsAsc) {
            this.defaultSort = { prop: 'brandNameCn', order: 'ascending' }
            this.prevSort = 'ascending'
          } else {
            this.defaultSort = { prop: 'brandNameCn', order: 'descending' }
            this.prevSort = 'descending'
          }
          this.prevProp = 'brandNameCn'
          break
      }
    }
    this.getBrandList(this.currentPage, this.pageSize, this.sort, this.IsAsc, this.searchText)
  },
  methods: {
    // 列表排序
    sortChange (column) {
      if (column.order !== null) {
        this.prevSort = column.order
        if (column.order === 'ascending') {
          this.IsAsc = true
          this.prevSort = 'ascending'
        } else if (column.order === 'descending') {
          this.prevSort = 'descending'
          this.IsAsc = false
        }
        if (this.prevProp !== column.prop) {
          var columns = this.$refs.table.columns.find(item => item.property === this.prevProp)
          columns.order = ''
        }
      }
      if (column.order === null) {
        column.column.order = this.prevSort === 'descending' ? 'ascending' : 'descending'
        column.order = this.prevSort === 'descending' ? 'ascending' : 'descending'
        this.prevProp = column.prop
        this.prevSort = column.column.order
        this.IsAsc = column.column.order !== 'descending'
      }
      switch (column.prop) {
        case 'sortNo':
          this.sort = 1
          break
        case 'brandNameCn':
          this.sort = 2
          break
        case 'updateDate':
          this.sort = 0
          break
      }
      this.updataRouteQuery()
      // 请求列表接口数据
      this.getBrandList(this.currentPage, this.pageSize, this.sort, this.IsAsc, this.searchText)
    },
    // 页数改变
    handleSizeChange (val) {
      this.pageSize = val
      this.updataRouteQuery()
      // 请求列表接口数据
      this.getBrandList(this.currentPage, this.pageSize, this.sort, this.IsAsc, this.searchText)
    },
    // 每页条数改变
    handleCurrentChange (val) {
      this.currentPage = val
      this.updataRouteQuery()
      // 请求列表接口数据
      this.getBrandList(this.currentPage, this.pageSize, this.sort, this.IsAsc, this.searchText)
    },
    // 列表模糊搜索
    searchDomainList () {
      this.updataRouteQuery()
      this.currentPage = 1
      this.getBrandList(this.currentPage, this.pageSize, this.sort, this.IsAsc, this.searchText)
    },
    // 删除品牌数据
    delBrandData () {
      this.$commonfun.confirm(this.$t('LanguageLib.ARE_YOU_SURE_YOU_WANT_TO_DELETE_IT1'), this.$t('LanguageLib.DELETE'), this.$t('LanguageLib.DETERMINE'), this.$t('LanguageLib.CANCEL'), false, 'warning', this)
        .then(() => {
          storeinformationApi.DelBrandData('post', '/store/brand/delete', this.selectRoleData)
            .then(res => {
              this.currentPage = 1
              this.getBrandList(this.currentPage, this.pageSize, this.sort, this.IsAsc, this.searchText)
              this.$message({
                type: 'success',
                message: this.$t('LanguageLib.SUCCESSFULLY_DELETED')
              })
            })
            .catch(err => {
              this.$commonfun.console.log(err)
            })
        }).catch(() => {
          this.$message({
            type: 'success',
            message: this.$t('LanguageLib.DeletionCancelled')
          })
        })
    },
    // 品牌批量选择
    selectionChange (selection) {
      this.selectRoleData = []
      for (let i = 0; i < selection.length; i++) {
        this.selectRoleData.push(selection[i].id)
      }
      if (this.selectRoleData.length === 0) {
        this.delDisabled = true
      } else {
        this.delDisabled = false
      }
    },
    // 添加品牌
    addBrand () {
      this.$router.push('/storeinformation/brandsetting/addbrand?currentPage=' + this.currentPage + '&pageSize=' + this.pageSize + '&searchText=' + this.$commonfun.encodeUrl(this.searchText) + '&sort=' + this.sort + '&IsAsc=' + this.IsAsc + '&type=add')
    },
    // 角色编辑
    editRole (data, index, tableData) {
      this.$router.push('/storeinformation/brandsetting/addbrand?currentPage=' + this.currentPage + '&pageSize=' + this.pageSize + '&searchText=' + this.$commonfun.encodeUrl(this.searchText) + '&sort=' + this.sort + '&IsAsc=' + this.IsAsc + '&type=edit&data=' + this.$commonfun.encodeUrl(JSON.stringify(data)))
    }
  },
  watch: {
  }
}
</script>

<style lang="scss">
ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.brandSet{
  width:100%;
  height: 100%;
}
.brandSet .left{
  background: #fff;
  width: 20%;
  float:left;
  height: 100%;
  border-right: 1px solid #f2f2f2;
  .treeBox{
    height: calc( 100% - 50px );
    overflow: auto;
    width: 100%;
  }
  .fifter{
    padding: 10px 0 10px 6%;
    line-height: 30px;
   .el-input{
      width: 60%;
    }
    .el-button--text{
      margin-left: 2.5%;
      padding: 2% 0;
      width: 20%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.brandSet .right{
  width: 100%;
  height: 100%;
  .operation{
    background: #fff;
    height: 30px;
    padding: 10px 0 10px 20px;
    border-bottom: 1px solid #f2f2f2;
    border-top: 1px solid #f2f2f2;
    .operationBtn{
      width: auto;
      display: inline-block;
      float:left;
      position: relative;
      .el-button{
        height: 30px;
        padding: 7px 20px;
      }
      .BatchSetting{
        background: #fff;
        color: #666666;
        position:absolute;
        left: 0;
        top: 30px;
        width:100px;
        font-size: 14px;
        text-align:center;
        box-shadow:0px 3px 6px 0px rgba(0,0,0,0.2);
        border-radius:2px;
        z-index: 99;
        li{
          line-height: 30px;
          cursor: pointer;
        }
      }
      .exportType{
        min-width: 100px;
        background: #fff;
        color: #666666;
        position:absolute;
        right: 0;
        top: 30px;
        font-size: 14px;
        text-align:center;
        box-shadow:0px 3px 6px 0px rgba(0,0,0,0.2);
        border-radius:2px;
        z-index: 99;
        li{
          line-height: 30px;
          cursor: pointer;
        }
        .upload{
          position: absolute;
          top: 30px;
          width: 100%;
          opacity: 0;
          .el-upload{
            width: 100%;
            button{
              width: 100%;
              padding-left: 0;
            }
          }
        }
      }
    }
    .operationSearch{
      float:right;
      padding-right: 51px;
      position: relative;
      .shaixuan{
        color: #999999;
        height: 15px;
        width: 15px;
        position: relative;
        top: 2px;
        margin-left: 10px;
        margin-right: 10px;
        font-weight: 600;
      }
      .shaixuan1{
        color: #3BC6B9;
      }
      .el-input{
        width: 160px;
        .el-input__inner{
          height: 30px;
          line-height: 30px;
          border-radius: 20px;
        }
      }
      .el-icon-search{
        line-height: 30px;
      }
    }
  }
  .tableParent{
    height: calc( 100% - 98px );
  }
  .el-pagination{
    padding: 8px 15px 5px;
    height: 35px;
    background: #fff;
  }
}
.brandSet .drawerTitle{
  height:25px;
  font-size:18px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(77,77,77,1);
  line-height:25px;
  margin-bottom: 20px;
}
.brandSet .drawerText{
  height:16px;
  font-size:14px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(77,77,77,1);
  line-height:16px;
  margin-bottom: 5px;
}
.cell{
    overflow: hidden;
    -webkit-line-clamp: 1;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }
.el-button--default{
  border:1px solid #3BC6B9;
  color:#3BC6B9;
}
.el-button--primary{
  background-color:#3BC6B9;
  color:#fff;
  border:none;
  margin-left: 10px;
}
.el-button--primary:hover{
  background-color:#3BC6B9;
  color:#fff;
  border:none;
}
/*.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
  background-color: #3BC6B9 !important;
  border-color: #3BC6B9 !important;
}*/
// 对于树组件配置特有的css
.el-tree-node>.el-tree-node__children{
  overflow: unset;
}
.el-tree-node__content{
  height: 48px;
}
.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content{
  background-color: #F6F6F6
}
// .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content>span:last-child{
//   color: #3BC6B9 !important;
// }
// .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content>ww-open-data{
//   color: #3BC6B9 !important;
// }
// 更改表格的滚动条样式
.el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar,
.el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar {
    width: 10px;
    height: 10px;
}
.el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar-thumb,
.el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-thumb {
  border-radius: 5px;
  -webkit-box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
  background: #E1E1E1;
}
.el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar-track,
.el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-track {
  border-radius: 5px;
  background: #fff;
}
// 抽屉组件样式修改
.el-drawer.rtl{
  outline: none;
}
.el-drawer__wrapper{
  top: 172px;
  bottom: 18px;
/*  right: 20px;*/
}
section.el-drawer__body{
  padding: 20px;
  .el-input{
    margin-bottom: 15px;
  }
}
.el-drawer__container{
  outline: none;
}
.colorG{
  height:20px;
  font-size:14px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(59,198,185,1);
  line-height:20px;
}
.el-table .descending .sort-caret.descending{
}
.el-table .ascending .sort-caret.ascending{
  border-bottom-color: #3BC6B9;
}
.el-pager li.active{
  color: #3BC6B9;
}
.el-table__fixed-body-wrapper .el-table__body{
    padding-bottom: 10px;
}
.filterContent{
  height: calc(100% - 154px);
  overflow: hidden;
  overflow-y: auto;
}
.filterContent::-webkit-scrollbar{
    width: 10px;
    height: 10px;
}
.filterContent::-webkit-scrollbar-thumb {
  border-radius: 5px;
  -webkit-box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
  background: #E1E1E1;
}
.filterContent::-webkit-scrollbar-track {
  border-radius: 5px;
  background: #fff;
}
.el-table-column--selection{
  text-align: center !important;
}
.el-tooltip__popper.is-light{
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
  border: 1px solid #E4E7ED !important;
  background-color: #fff;
  color: #000;
  .popper__arrow{
    border-top-color: #E4E7ED;
    border: #E4E7ED;
  }
  .popper__arrow::after{
    border-top-color: #fff;
  }
}
.ExcalDialog{
  .el-dialog{
    width: 1000px !important;
    .el-dialog__body{
      height: 350px;
      overflow-y: auto;
    }
    .checkFiled{
      height: 100%;
      border-right: 1px solid #D8DCE6;
      width: calc(70% - 21px);
      padding-right: 20px;
      float: left;
      h4 {
        font-size: 14px;
        color: #999999;
        font-weight: normal;
        padding-bottom: 10px;
        border-bottom: 1px solid #D8DCE6;
        margin-bottom: 15px;
      }
      .contentTop{
        margin-bottom: 15px;
      }
      .el-checkbox{
        margin-bottom: 15px;
      }
    }
    .showFiled{
      width: calc(30% - 20px);
      float: left;
      padding-left: 20px;
      li{
        margin-top: 10px;
        position: relative;
        span{
          padding-right: 20px;
          display: block;
        }
        .el-icon-close{
          position: absolute;
          right: 0;
          top: 3px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
